/* eslint-disable react/no-danger */
import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { globalHistory } from '@reach/router'
import { useStaticQuery, graphql } from 'gatsby'
import logo from 'static/logo/logo_small.png'

function SEO({ description, lang, meta, title, image, type, author, path = '/' }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )
  const metaDescription = description || site.siteMetadata.description
  let metaImage =
    image && image.indexOf('http') === 0 ? image : `${process.env.GATSBY_SITE_URL}${image || '/img/logo_inverted.png'}`

  metaImage = metaImage.replace('cms.agencyvista.com', 'media.agencyvista.com')
  const metaTitle = title ? `${title} | Agency Vista` : 'Agency Vista'
  const metaType = type || 'website'
  return (
    <React.Fragment>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify([
            {
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: 'Agency Vista',
              legalName: 'Agency Vista LLC',
              url: 'https://agencyvista.com/',
              logo: 'https://agencyvista.com/img/logo_inverted.png',
              foundingDate: '2019',
              alternateName: 'AgencyVista',
              sameAs: [
                'https://facebook.com/AgencyVistaOfficial',
                'https://twitter.com/AgencyVista',
                'https://linkedin.com/company/agencyvista',
                'https://instagram.com/AgencyVistaOfficial',
              ],
              contactPoint: {
                '@type': 'ContactPoint',
                contactType: 'Customer Support',
                email: 'yourfriends@agencyvista.com',
              },
            },
          ]),
        }}
      />

      <Helmet
        htmlAttributes={{ lang }}
        title={metaTitle}
        meta={[
          {
            property: `canonical`,
            content: `${process.env.GATSBY_SITE_URL}${path}`,
          },
          {
            name: `author`,
            content: author,
          },
          {
            name: `description`,
            content: metaDescription,
          },
          {
            property: `og:title`,
            content: metaTitle,
          },
          {
            property: `og:description`,
            content: metaDescription,
          },
          {
            property: `og:type`,
            content: metaType,
          },
          {
            property: `og:image`,
            content: metaImage,
          },
          // { property: `og:image:width`, content: '400' },
          // { property: `og:image:height`, content: '225' },
          { property: 'og:image:alt', content: metaTitle },
          {
            property: `og:url`,
            content: `${process.env.GATSBY_SITE_URL}${path}`,
          },
          {
            name: `twitter:card`,
            content: `summary_large_image`,
          },
          {
            property: `fb:app_id`,
            content: `2353633811554118`,
          },
          {
            name: `twitter:creator`,
            content: site.siteMetadata.author,
          },
          {
            name: `twitter:title`,
            content: metaTitle,
          },
          {
            name: `twitter:description`,
            content: metaDescription,
          },
          {
            name: `twitter:image`,
            content: metaImage,
          },
        ].concat(meta)}
      />
    </React.Fragment>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  image: PropTypes.string,
  type: PropTypes.string,
  author: PropTypes.string,
  path: PropTypes.string,
}

export default SEO
